/*
 *
 * Config actions
 *
 */
export default function action(type: any, payload: any = null) {
  if (payload !== null) {
    return {
      type,
      payload,
    };
  }
  return {
    type,
  };
}
